/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PrimeDatatableParams } from '../../models/prime-datatable-params';
import { WebSiteRequestViewModelPrimeDatatableResults } from '../../models/web-site-request-view-model-prime-datatable-results';

export interface ListWebSiteRequests$Params {
      body?: PrimeDatatableParams
}

export function ListWebSiteRequests(http: HttpClient, rootUrl: string, params?: ListWebSiteRequests$Params, context?: HttpContext): Observable<StrictHttpResponse<WebSiteRequestViewModelPrimeDatatableResults>> {
  const rb = new RequestBuilder(rootUrl, ListWebSiteRequests.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WebSiteRequestViewModelPrimeDatatableResults>;
    })
  );
}

ListWebSiteRequests.PATH = '/api/Developer/ListWebSiteRequests';
